import * as API from '@/services/API';

const buildQuery = (filters: Record<string, string | number | undefined | null>) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    params.append(key, String(value));
  });
  return params.toString();
};

export default {
  getSummary(filters: Record<string, string | number | undefined | null> = {}) {
    const query = buildQuery(filters);
    return API.apiClient.get('/api/dashboard/summary' + (query ? `?${query}` : ''));
  },
  getInventoryCompanies(filters: Record<string, string | number | undefined | null> = {}) {
    const query = buildQuery(filters);
    return API.apiClient.get('/api/dashboard/inventory/companies' + (query ? `?${query}` : ''));
  },
  getInventoryCompanyDetail(id: number, filters: Record<string, string | number | undefined | null> = {}) {
    const query = buildQuery(filters);
    return API.apiClient.get(`/api/dashboard/inventory/company/${id}` + (query ? `?${query}` : ''));
  },
};
